var alignment_rtlignore_default = {
  "alignLeft": "B4sxE",
  "textWrapNowrap": "JBFMH",
  "alignRight": "S2OJa",
  "alignCenter": "xWkzF",
  "sizeFullWidth": "lvtY7",
  "renderedInTable": "_1ME-s",
  "sizeOriginal": "aPTps",
  "sizeContent": "VbJtq",
  "sizeSmall": "cn3M3",
  "sizeSmallCenter": "su8eR",
  "flex": "aQbsi",
  "LEFT": "ch2Kb",
  "CENTER": "F5qm8",
  "RIGHT": "_5w6g7",
  "AUTO": "h8LWG",
  "JUSTIFY": "S9i2-"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
